<div class="sw-cms-preview-product-finder">
    <div class="preview-block-container">
        <div class="block-icon">
            <mt-icon name="regular-search" size="40px"></mt-icon>
        </div>
        
        <div class="block-content">
            <h4>{{ $tc('sw-cms.blocks.commerce.productFinder.preview.title') }}</h4>
            <p>{{ $tc('sw-cms.blocks.commerce.productFinder.preview.description') }}</p>
            
        
        </div>
    </div>
</div>